import { useCurrentProject } from "@radarly/core/project/use-cases";

export function useCorpora() {
  return useCurrentProject()?.corpora;
}
